import { render, staticRenderFns } from "./InactivityIntervalsListTable.vue?vue&type=template&id=14bc5659&scoped=true&"
import script from "./InactivityIntervalsListTable.vue?vue&type=script&lang=ts&"
export * from "./InactivityIntervalsListTable.vue?vue&type=script&lang=ts&"
import style0 from "./InactivityIntervalsListTable.vue?vue&type=style&index=0&id=14bc5659&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bc5659",
  null
  
)

export default component.exports